import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { Employee } from '@trackkm/shared';

interface AuthState {
  readonly token: string | null;
  readonly employee: Employee | null;
  readonly isAuthenticated: boolean;
  readonly mustChangePin: boolean;
}

interface AuthActions {
  readonly login: (token: string, employee: Employee, mustChangePin: boolean) => void;
  readonly logout: () => void;
  readonly setEmployee: (employee: Employee) => void;
  readonly clearMustChangePin: () => void;
}

type AuthStore = AuthState & AuthActions;

const INITIAL_STATE: AuthState = {
  token: null,
  employee: null,
  isAuthenticated: false,
  mustChangePin: false,
};

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      ...INITIAL_STATE,

      login: (token: string, employee: Employee, mustChangePin: boolean) =>
        set({
          token,
          employee,
          isAuthenticated: true,
          mustChangePin,
        }),

      logout: () =>
        set({ ...INITIAL_STATE }),

      setEmployee: (employee: Employee) =>
        set({ employee }),

      clearMustChangePin: () =>
        set({ mustChangePin: false }),
    }),
    {
      name: 'trackkm-auth',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        token: state.token,
        employee: state.employee,
        isAuthenticated: state.isAuthenticated,
        mustChangePin: state.mustChangePin,
      }),
    },
  ),
);
